import FButton from "@components/FButton";

interface ButtonSubmitForReviewProps {
  onSubmitForReview: () => void;
  isLoading: boolean;
}

const ButtonSubmitForReview = ({
  onSubmitForReview,
  isLoading,
}: ButtonSubmitForReviewProps) => (
  <FButton
    onClick={(e) => {
      e.stopPropagation();

      onSubmitForReview();
    }}
    loading={isLoading}
    primary
    label="Submit for Review"
    icon={{
      name: "fancy-arrow-right",
      size: 16,
      color: "#fff",
      className: "ml-2",
    }}
    className="py-3 sm:py-4 font-sm bg-red"
  />
);

export default ButtonSubmitForReview;
